(() => {
  function status(button, message) {
    const scope = button.closest('[data-sg-download-library]');
    const output = scope && scope.querySelector('[data-sg-action-status]');
    if (output) { output.textContent = message; }
    const original = button.textContent;
    button.textContent = message;
    window.setTimeout(() => { button.textContent = original; }, 2400);
  }
  async function copy(text) {
    if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(text); return; }
    const field = document.createElement('textarea');
    field.value = text; field.style.position = 'fixed'; field.style.opacity = '0';
    document.body.appendChild(field); field.select();
    const success = document.execCommand('copy'); field.remove();
    if (!success) throw new Error('Copy unavailable');
  }
  function simplifyActions() {
    document.querySelectorAll('[data-sg-download-library] .sg-consistent-actions').forEach(group => {
      const downloads = [...group.querySelectorAll('[data-sg-download]')];
      downloads.slice(1).forEach(a => a.remove());
      group.querySelectorAll('a:not([data-sg-download])').forEach(a => a.remove());
      downloads.slice(0,1).forEach(a => a.textContent = 'Download');
      group.querySelectorAll('[data-sg-share]').forEach(a => a.textContent = 'Share');
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', simplifyActions); else simplifyActions();
  document.addEventListener('click' , async event => {
    const button = event.target.closest('[data-sg-share],[data-sg-copy-embed],[data-sg-download]');
    if (!button || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (button.matches('[data-sg-download]')) {
      event.preventDefault();
      const url = new URL(button.href, location.href);
      try {
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Download unavailable');
        const blob = await response.blob();
        const objectURL = URL.createObjectURL(blob);
        const link = document.createElement('a'); link.href = objectURL;
        link.download = button.getAttribute('download') || url.pathname.split('/').pop();
        document.body.appendChild(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(objectURL), 60000);
        status(button, 'Download started');
      } catch (_) { window.location.assign(url.href); }
      return;
    }
    try {
      if (button.hasAttribute('data-sg-copy-embed')) {
        await copy(button.closest('details').querySelector('textarea').value);
        status(button, 'Embed code copied');
      } else {
        const url = button.dataset.sgShare;
        if (navigator.share) await navigator.share({ title: button.dataset.sgShareTitle, url });
        else { await copy(url); status(button, 'Link copied'); }
      }
    } catch (error) { if (error.name !== 'AbortError') status(button, 'Sharing unavailable. Please copy this page’s address.'); }
  });
})();

